module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/trust-and-transparecy-1200x630.8a95e339.jpg";